import { useState, useEffect } from "react";
import { Dialog, DialogContent, DialogHeader, DialogTitle } from "./ui/dialog";
import { Button } from "./ui/button";
import { UserCard } from "./UserCard";
import { Loader2 } from "lucide-react";
import axios from "axios";
import { useTranslation } from "../i18n";

const API = '/api';

export function FollowersModal({ open, onOpenChange, username, mode = "followers", displayName }) {
  const { t } = useTranslation();
  const [users, setUsers] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hasMore, setHasMore] = useState(false);
  const [skip, setSkip] = useState(0);
  const limit = 20;

  useEffect(() => {
    if (open) { setUsers([]); setSkip(0); fetchPage(0); }
  }, [open, username, mode]);

  const fetchPage = async (offset) => {
    setLoading(true);
    try {
      const res = await axios.get(`${API}/profile/${username}/${mode}?limit=${limit}&skip=${offset}`);
      if (offset === 0) setUsers(res.data.users);
      else setUsers(prev => [...prev, ...res.data.users]);
      setHasMore(res.data.has_more);
    } catch (err) { console.error(err); }
    finally { setLoading(false); }
  };

  const loadMore = () => {
    const next = skip + limit;
    setSkip(next);
    fetchPage(next);
  };

  const title = mode === "followers"
    ? t.social.followersOf(displayName)
    : t.social.followingOf(displayName);

  const emptyMsg = mode === "followers" ? t.social.noFollowers : t.social.noFollowing;

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-md max-h-[70vh] flex flex-col" data-testid={`${mode}-modal`}>
        <DialogHeader>
          <DialogTitle>{title}</DialogTitle>
        </DialogHeader>
        <div className="flex-1 overflow-y-auto space-y-2">
          {users.map(u => (<UserCard key={u.user_id} user={u} />))}
          {!loading && users.length === 0 && (
            <p className="text-center text-muted-foreground py-8 text-sm">{emptyMsg}</p>
          )}
          {loading && (
            <div className="flex justify-center py-4">
              <Loader2 className="w-5 h-5 animate-spin text-muted-foreground" />
            </div>
          )}
          {hasMore && !loading && (
            <Button variant="ghost" className="w-full" onClick={loadMore}>
              {t.social.loadMore}
            </Button>
          )}
        </div>
      </DialogContent>
    </Dialog>
  );
}
